import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-modal-footer',
  templateUrl: './custom-modal-footer.component.html',
  styleUrls: ['./custom-modal-footer.component.scss']
})
export class CustomModalFooterComponent {
  @Input() cancelLabel = 'Cancelar';
  @Input() cancelDisabled: boolean = false;
  @Input() hideCancel: boolean = false;
  @Input() hideSave: boolean = false;
  @Input() saveLabel = 'Salvar Alterações';
  @Input() saveDisabled: boolean = false;
  @Input() buttonImage: string = undefined;
  @Input() customButtonLabel = 'Salvar & Imprimir';
  @Input() customButtonDisabled: boolean = false;
  @Input() showCustomButton: boolean = false;

  @Output() onCancelClick = new EventEmitter<number>();
  @Output() onSaveClick = new EventEmitter<number>();
  @Output() onCustomButtonClick = new EventEmitter<number>();

}
